module.exports = __webpack_public_path__ + "static/media/20170329_123452.536cd536.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/20170329_123452.jpg
// module id = 454
// module chunks = 0